/* eslint-disable no-const-assign */
import SlsTracker from '@aliyun-sls/web-track-browser'
import $store from '@/store'

export class BuriedPointUtils {
  static Send(moduleName, functionName, actionName) {
    const HOST = window.location.hostname
    let logstore = ''
    // 埋点域名判断，'cargoware.hi-strong.com'为生产域名，除生产域名外，其余域名全部取值'cargo-stage'
    if (HOST === 'cargoware.hi-strong.com') {
      logstore = 'cargo-production'
    } else {
      logstore = 'cargo-stage'
    }
    const OPTS = {
      host: 'cn-shanghai.log.aliyuncs.com', // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
      project: 'cargo-log-1', // Project名称。
      logstore: logstore // Logstore名称。
    }
    const TRACKER = new SlsTracker(OPTS)
    TRACKER.send({
      moduleName: moduleName, // 模块名称。比如 【海运出口】【销售】
      functionName: functionName, // 菜单名称。比如 【海运出口极速版】
      actionName: actionName, // 动作名称。比如 在自动对账里面，对账完成，点击【保存】
      tenantId: $store.getters.tenantId, // 租户ID
      userId: $store.getters.userId // 当前用户ID
    })
  }
}
